import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import { CookieBanner } from './components/CookieBanner';
import { Landing } from './pages/Landing';
import { LegalPage } from './pages/LegalPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbjcb6vrpzx0">
      <CookieConsentProvider data-id="element-1" data-mp="3fb19frelong4">
        <Routes data-id="element-2" data-mp="2rkx33ca129lf">
          <Route path="/" element={<Landing data-id="element-4" data-mp="2rlypue0eokiz" />} data-id="element-3" data-mp="2rknlabz4z8qt" />
          <Route path="/legal/:slug" element={<LegalPage data-id="element-6" data-mp="2mlubatj25zve" />} data-id="element-5" data-mp="2rl6un4aq0ot8" />
          <Route path="*" element={<Landing data-id="element-8" data-mp="2mn5f2tci77mi" />} data-id="element-7" data-mp="2mmlut5zds75b" />
        </Routes>
        <CookieBanner data-id="element-9" data-mp="31aqdwb2cikom" />
      </CookieConsentProvider>
    </BrowserRouter>;
}